import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import translate from '../../../../../commonComponents/translate';

function ExpirationRiskAlerts({ t, data }) {
  const [showDetails, setShowDetails] = useState(false);

  if (!data || data.length === 0) return null;

  return (
    <div className="pureliink-risk-alert">
      <div className="pureliink-risk-alert__header">
        <h4>⚠️ {t('pureliink.career.expirationRisk.title')}</h4>
        <div className="pureliink-risk-alert__actions">
          <span className="pureliink-risk-alert__count-badge">
            {data.length}{' '}
            {t('pureliink.career.expirationRisk.affiliatesAtRisk')}
          </span>
          <button
            className="btn btn-sm btn-outline-danger pureliink-risk-alert__toggle-btn"
            type="button"
            onClick={() => setShowDetails(prev => !prev)}
          >
            {showDetails
              ? t('pureliink.career.expirationRisk.hide')
              : t('pureliink.career.expirationRisk.show')}
          </button>
        </div>
      </div>

      <div className="pureliink-risk-alert__objective">
        📌{' '}
        <strong>{t('pureliink.career.expirationRisk.objectiveLabel')}</strong>{' '}
        {t('pureliink.career.expirationRisk.objective')}
      </div>

      {showDetails && (
        <>
          <div className="table-responsive">
            <table className="table m-table my-0">
              <thead>
                <tr>
                  <th>{t('name')}</th>
                  <th>{t('email')}</th>
                  <th>{t('pureliink.career.expirationRisk.lastOrder')}</th>
                  <th className="text-center">
                    {t('pureliink.career.expirationRisk.monthsWithout')}
                  </th>
                  <th className="text-center">{t('status')}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, i) => (
                  <tr key={i}>
                    <td>
                      <strong>{item.name}</strong>
                    </td>
                    <td>{item.email}</td>
                    <td>
                      {item.lastOrderDate
                        ? moment(item.lastOrderDate).format('DD/MM/YYYY')
                        : '-'}
                    </td>
                    <td className="text-center">
                      <span
                        className={`pureliink-risk-months-badge pureliink-risk-months-badge--${
                          item.status === 'CRITICAL' ? 'critical' : 'warning'
                        }`}
                      >
                        {item.monthsWithoutOrders ?? '-'}{' '}
                        {t('pureliink.career.expirationRisk.months')}
                      </span>
                    </td>
                    <td className="text-center" style={{ fontSize: '1.2rem' }}>
                      {item.status === 'CRITICAL' ? '🔴' : '🟡'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="pureliink-risk-alert__suggestions">
            <strong>
              💡 {t('pureliink.career.expirationRisk.suggestedActions')}
            </strong>
            <ul>
              <li>{t('pureliink.career.expirationRisk.action2')}</li>
              <li>{t('pureliink.career.expirationRisk.action3')}</li>
              <li>{t('pureliink.career.expirationRisk.action4')}</li>
            </ul>
          </div>
        </>
      )}
    </div>
  );
}

ExpirationRiskAlerts.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
      lastOrderDate: PropTypes.number,
      monthsWithoutOrders: PropTypes.number,
      status: PropTypes.oneOf(['CRITICAL', 'WARNING']),
    }),
  ).isRequired,
};

export default translate(ExpirationRiskAlerts);
